import "./BillingClient.scss";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import { BILLING_CLIENT_FORM_LABELS } from "constants/forms";
import {
  renderInputEmail,
  renderInputAccountingFirstName,
  renderInputAccountingLastName,
} from "../CommonInputs";
import PropTypes from "prop-types";
import { useContext } from "react";
import InfoContext from "pages/InfoContext";

const BillingAccountantInfoForm = ({
  control,
  register,
  setValue,
  errors,
  readOnly = false,
  watch,
  cellHighlight,
}) => {
  const { slug, setCode, setStatus } = useContext(InfoContext);

  return (
    <div className="billing-info-wrapper">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="accounting_infos"
            defaultMessage="Contact comptabilité fournisseurs"
          />
        }
      />
      <div className="accountability-info">
        <div className="center-block">
          <div className="line-1">
            <div className="cell-padding">
              {renderInputAccountingFirstName({
                control,
                errors,
                label: BILLING_CLIENT_FORM_LABELS.accounting_contact_first_name,
                placeholder:
                  BILLING_CLIENT_FORM_LABELS.accounting_contact_first_name,
                readOnly,
                register,
                setValue,
              })}
            </div>
            <div className="cell-padding">
              {renderInputAccountingLastName({
                control,
                errors,
                label: BILLING_CLIENT_FORM_LABELS.accounting_contact_last_name,
                placeholder:
                  BILLING_CLIENT_FORM_LABELS.accounting_contact_last_name,
                readOnly,
                register,
                setValue,
              })}
            </div>
          </div>
          <div className="line-2">
            <div
              className={`cell-padding ${
                !watch("accounting_contact_email") &&
                cellHighlight &&
                "errorCellColor"
              }`}
            >
              {renderInputEmail({
                control,
                errors,
                label: BILLING_CLIENT_FORM_LABELS.accounting_contact_email,
                placeholder:
                  BILLING_CLIENT_FORM_LABELS.accounting_contact_email,
                readOnly,
                register,
                setValue,
                name: "accounting_contact_email",
                errorMessage:
                  errors?.["accounting_contact_email"]?.message || null,
                copyEmail: slug,
                setCode,
                setStatus,
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingAccountantInfoForm;

BillingAccountantInfoForm.propTypes = {
  control: PropTypes.object,
  register: PropTypes.func,
  setValue: PropTypes.func,
  errors: PropTypes.object,
  readOnly: PropTypes.bool,
};
